import _ from "lodash";
import React from "react";
import MoreItemWithToolTipV2 from "UIComponents/MoreItemWithToolTipV2";

const GradeLevelsCell = ({ columnData }) => {
  const { gradeLevels } = columnData;

  if (_.isEmpty(gradeLevels)) {
    return "-";
  }

  return (
    <MoreItemWithToolTipV2
      items={gradeLevels}
      length={2}
      customClass="text-body"
      toolTipItemTextClass="text-body"
      moreJoinSymbol=" +"
    />
  );
};

export default GradeLevelsCell;
